import React from 'react';
import { HomeIcon, PlusIcon, Trash2Icon } from 'lucide-react';
import { CurrencyField } from './CurrencyField';
import { PanelCard } from './PanelCard';
import { RentalUnit } from '../types/dscr';
import { formatCurrency, totalRent } from '../utils/dscr';
interface RentalIncomePanelProps {
  units: RentalUnit[];
  onChangeRent: (id: string, value: number) => void;
  onChangeLabel: (id: string, label: string) => void;
  onAddUnit: () => void;
  onRemoveUnit: (id: string) => void;
}
export function RentalIncomePanel({
  units,
  onChangeRent,
  onChangeLabel,
  onAddUnit,
  onRemoveUnit
}: RentalIncomePanelProps) {
  const total = totalRent(units);
  return <PanelCard title="Rental Income" icon={<HomeIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="1tv0oorcirl09" />} action={<button type="button" onClick={onAddUnit} className="inline-flex items-center gap-1.5 rounded border border-[#0176d3] bg-white px-3 py-1.5 text-xs font-semibold text-[#0176d3] transition hover:bg-[#0176d3] hover:text-white focus:outline-none focus:ring-2 focus:ring-[#0176d3]/40" data-id="element-49" data-mp="1yvezgh5i991z">
          <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-50" data-mp="1mp01ai3xhsmo" />
          Add unit
        </button>} className="h-full" data-id="element-47" data-mp="1pwl3mt000mph">
      <ul className="mb-5 space-y-3" data-id="element-51" data-mp="1iqkae34q803z">
        {units.map((unit, index) => <li key={unit.id} className="flex items-center gap-2" data-id="element-52" data-mp="1dqxx5towejv6" data-mpi={index}>
            <div className="flex-1" data-id="element-53" data-mp="2afvrjasqkfrt">
              <label htmlFor={`unit-name-${unit.id}`} className="sr-only" data-id="element-54" data-mp="2aeufb2zzhn8i">
                {`Name for unit ${index + 1}`}
              </label>
              <input id={`unit-name-${unit.id}`} value={unit.label} onChange={event => onChangeLabel(unit.id, event.target.value)} placeholder={`Unit ${index + 1}`} className="w-full rounded border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-900 shadow-sm outline-none transition focus:border-[#0176d3] focus:ring-2 focus:ring-[#0176d3]/30" data-id="element-55" data-mp="21n2b3a1jzacd" />
            </div>
            <div className="w-40" data-id="element-56" data-mp="38bhm2g0f6j4c">
              <CurrencyField id={`rent-${unit.id}`} label={`Income for ${unit.label || `unit ${index + 1}`}`} hideLabel value={unit.monthlyRent} onChange={value => onChangeRent(unit.id, value)} data-id="element-57" data-mp="3d8hqkmhmfdtc" />
            </div>
            <button type="button" onClick={() => onRemoveUnit(unit.id)} disabled={units.length <= 1} aria-label={`Remove ${unit.label || `unit ${index + 1}`}`} className="rounded border border-transparent p-2 text-slate-400 transition hover:border-slate-200 hover:bg-slate-50 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-30 focus:outline-none focus:ring-2 focus:ring-[#0176d3]/40" data-id="element-58" data-mp="2phm321k774rw">
              <Trash2Icon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="ispkadpg2m4f" />
            </button>
          </li>)}
      </ul>

      <div className="mt-auto flex items-baseline justify-between rounded border border-slate-200 bg-slate-50 px-4 py-3" data-id="element-60" data-mp="23b1k2bz2lw5d">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-61" data-mp="1zahld3yumkh4">
          Total monthly rental income
        </span>
        <span className="text-lg font-semibold tabular-nums text-slate-900" data-id="element-62" data-mp="288tat2nzbc7z">
          {formatCurrency(total)}
        </span>
      </div>
    </PanelCard>;
}